"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _styles = require("./styles");

var _ref =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.Container, {}, void 0, (0, _jsx2["default"])("svg", {
  className: "spinner",
  width: "65px",
  height: "65px",
  viewBox: "0 0 66 66",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, (0, _jsx2["default"])("circle", {
  className: "path",
  fill: "none",
  strokeWidth: "6",
  strokeLinecap: "round",
  cx: "33",
  cy: "33",
  r: "30"
})));

var _default = function _default() {
  return _ref;
};

exports["default"] = _default;